import { render } from "./checkComponent.vue?vue&type=template&id=7b2745e0"
import script from "./checkComponent.vue?vue&type=script&lang=js"
export * from "./checkComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__